var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "url(#pattern55)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern55",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4106_9076",
    transform: "translate(-0.0170455) scale(0.0265152 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4106_9076",
    width: 39,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAhCAYAAABa+rIoAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJ6ADAAQAAAABAAAAIQAAAACxdDcIAAABuUlEQVRYCe1X7VHCQBAF9b90wGgDYgWOFYAlWIEdOJSgFRBLsAAHqAA7cKwAKMCJ7zHZuOwk4e5ykfvBzjxu924/3u0xl6TX+5MJ1DmwBnIP0H8EdCYzZPYhZH07I8iO2WIhdicEF4pcBv0KOHPELfw2gGwmKsE+EjPhAKBcA987zf3nBq5z4LIIIdmXQvcZGPcJLHWQ7Jqja8esn+2gzumrr8BjJAR1sC3qY8ck+AVyAx4ryYmcixI48ogngbHDIlb+Hm/ME6tzPl2u831QfFaxO8fNtpUfScAdJCsncqFHc+pcCp3jHfcBcIwmMe65e7BZA8zFkU+Lurvs0Lzm0/oSfixI6aQkyAv1EJGqdZ2nFbkqYjo516sINM3p+GByGQrrRHX61JOgzrNXoGlHes2VmBSaeRCUmLyPIBoiLm8lT3AeS0Ax3hmb5tLMvcN+NXNVZvlsDSHXmFAtumxUuZdqSY5HlawkT26rWjdU+jFUXX/LzvGLR+QZinaQ+f8YWZf1RXa8+M6fJ4jyWyRLjNwUfPaETBfABjhGJ1mX9cuO8Z6LIdyMlda5k75KLux2A237qApMsx/2C98zN0/atwq1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/upload-folder.79930a6696a3e975547022ce2df2b7f8.svg";
export { ForwardRef as ReactComponent };